
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["time"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "built-clock.0f0d3b.worker.js", { name: "built-clock.[hash:6].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			